/* Fransk katalog for locale-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'sup.archiveBody': 'Voulez-vous archiver {name} ? Le fournisseur est masqué des listes de fournisseurs actifs, mais les factures, paiements et historique sont conservés. Vous pourrez rouvrir le fournisseur plus tard.',
  'cust.title': 'Clients',
  'cust.subtitle': 'Tous vos clients au même endroit',
  'cust.searchPh': 'Rechercher un client ou un montant',
  'cust.titleHelp': 'Votre fichier clients — tous les clients avec coordonnées, encours et ventes totales. Touchez un client pour voir le suivi et les factures.',
  'cust.searchHelp': 'Recherchez des clients par nom, e-mail, ventes totales ou montant dû.',
  'cust.uploadHelp': 'Importer des clients depuis un fichier.',
  'cust.downloadHelp': 'Télécharger la liste des clients au format CSV ou Excel.',
  'cust.addHelp': 'Ajouter un nouveau client avec coordonnées et statut de suivi.',
  'cust.filterHelp': 'Filtrez les clients par statut (actif, prospect, devis envoyé, en pause), selon qu\'ils ont un encours, et indiquez si les clients archivés doivent s\'afficher.',
  'cust.listHelpTitle': 'La liste des clients',
  'cust.listHelp': 'Chaque ligne est un client avec n° client, n° d\'org., e-mail, téléphone, encours et ventes totales. Touchez une ligne pour ouvrir le client.',
  'cust.filterOther': 'Autre',
  'cust.filterWithOutstanding': 'Uniquement avec encours',
  'cust.filterShowArchive': 'Afficher les archives',
  'cust.archived': 'Archivé',
  'cust.followUpInline': 'Suivi {date}',
  'cust.col.customer': 'Client',
  'cust.col.number': 'N° client',
  'cust.col.org': 'N° d\'org.',
  'cust.col.email': 'E-mail',
  'cust.col.phone': 'Téléphone',
  'cust.col.outstanding': 'Encours',
  'cust.col.totalSales': 'Ventes totales',
  'cust.outstandingInline': 'Encours {amount}',
  'cust.balance.customerOwes': 'Le client vous doit {amount}',
  'cust.balance.youOwe': 'Vous devez {amount} au client',
  'cust.balance.settled': 'À jour',
  'cust.followUp': 'Suivi',
  'cust.followUpHelp': 'Statut, prochaine date de suivi, notes et dernières activités du client. Utilisez le bouton de chat pour consigner un échange et créer un devis.',
  'cust.dialogTitle': 'Dialogue client',
  'cust.dialogHelp': 'Ouvrez une conversation avec le client — consignez les messages et constituez une base de devis que vous pourrez transformer en devis.',
  'cust.openChat': 'Ouvrir le chat',
  'cust.startChat': 'Démarrer le chat',
  'cust.nextFollowUp': 'Prochain suivi',
  'cust.noFollowUpDate': 'Aucune date définie',
  'cust.status': 'Statut',
  'cust.salesTitle': 'Ventes au client',
  'cust.salesHelp': 'Toutes les factures et tous les avoirs du client. Filtrez sur tous, non payés ou payés — et ouvrez une facture directement avec « Ouvrir ».',
  'cust.salesAll': 'Tous',
  'cust.salesUnpaid': 'Non payé',
  'cust.salesPaid': 'Payé',
  'cust.salesTotal': 'Total',
  'cust.noSalesMatch': 'Aucune vente ne correspond au filtre.',
  'cust.creditNote': 'Avoir',
  'cust.invoice': 'Facture',
  'cust.dueOn': 'Échéance le {date}',
  'cust.open': 'Ouvrir',
  'cust.pageRange': '{from}-{to} sur {total}',
  'cust.prev': 'Précédent',
  'cust.next': 'Suivant',
  'cust.act.newInvoice': 'Nouvelle facture',
  'cust.act.newInvoiceHelp': 'Commencer une nouvelle facture avec ce client déjà sélectionné.',
  'cust.act.edit': 'Modifier',
  'cust.act.editHelp': 'Modifier les coordonnées, le statut et le suivi du client.',
  'cust.act.merge': 'Fusionner',
  'cust.act.mergeHelp': 'Fusionner deux clients enregistrés en double — les ventes et encours sont regroupés sur un seul client.',
  'cust.act.archive': 'Archiver',
  'cust.act.archiveHelp': 'Masquer le client des listes actives. Les factures, paiements et historique sont conservés.',
  'cust.act.menu': 'Action',
  'cust.archiveTitle': 'Archiver ?',
  'cust.archiveBody': 'Voulez-vous archiver {name} ? Le client est masqué des listes de clients actifs, mais les factures, paiements et historique sont conservés.',
  'cust.archiveStillUsed': 'Le client est encore utilisé ailleurs',
  'cust.archiveGroup': '{n} groupe de clients',
  'cust.archiveGroups': '{n} groupes de clients',
  'cust.archiveSubscription': '{n} abonnement',
  'cust.archiveSubscriptions': '{n} abonnements',
  'cust.archiveAnd': ' et ',
  'cust.merge.title': 'Fusionner des clients',
  'cust.merge.keep': 'Conservé',
  'cust.merge.remove': 'Fusionné et supprimé',
  'cust.merge.swap': 'Inverser le client conservé',
  'cust.merge.after': 'Après la fusion',
  'cust.merge.name': 'Nom du client',
  'cust.merge.totalSales': 'Ventes totales',
  'cust.merge.notConnected': 'La fusion n\'est pas encore connectée au serveur.',
  'cust.merge.done': 'Les clients ont été fusionnés',
  'cust.merge.failed': 'Impossible de fusionner les clients.',
  'cust.form.name': 'Nom du client',
  'cust.form.namePh': 'Ex. Exemple AS',
  'cust.form.orgOptional': 'N° d\'organisation (facultatif)',
  'cust.form.org': 'N° d\'organisation',
  'cust.form.address': 'Adresse',
  'cust.form.addressPh': 'Adresse postale',
  'cust.form.zip': 'Code postal',
  'cust.form.city': 'Ville',
  'cust.form.cityPh': 'Ville',
  'cust.form.crm': 'Statut client',
  'cust.form.nextLabel': 'Prochain : {date}',
  'cust.form.noFollowUp': 'Aucun suivi',
  'cust.form.dupTitle': 'Cette information existe déjà pour un autre client',
  'cust.form.dupName': '{names} a le même nom.',
  'cust.form.dupOrg': '{names} a le même numéro d\'organisation.',
  'cust.form.dupEmail': '{names} a la même adresse e-mail.',
  'cust.form.dupPhone': '{names} a le même numéro de téléphone.',
  'cust.form.dupUnnamed': 'Un client sans nom',
  'cust.form.dupBody': 'Le client est enregistré normalement. S\'il s\'agit du même client, vous pouvez fusionner les deux depuis la fiche client dans la liste.',
  'cust.form.contacts': 'Personnes de contact',
  'cust.form.contactsSub': 'Peuvent être choisies comme destinataires lorsque vous envoyez une facture, un devis ou un reçu.',
  'cust.form.addContact': 'Ajouter une personne de contact',
  'cust.form.editContact': 'Modifier la personne de contact',
  'cust.form.contactFallback': 'Personne de contact {n}',
  'cust.form.removeContact': 'Supprimer la personne de contact',
  'cust.form.contactTitle': 'Personne de contact',
  'cust.form.newTitle': 'Nouveau client',
  'cust.form.editTitle': 'Modifier le client',
  'cust.form.saveContact': 'Enregistrer',
  'cust.form.contactName': 'Nom',
  'cust.form.contactNamePh': 'Ex. Kari Nordmann',
  'cust.form.contactRole': 'Rôle',
  'cust.form.contactRolePh': 'Ex. Comptabilité',
  'cust.form.defaultRef': 'Référence de facturation fixe',
  'cust.form.defaultRefPh': 'Ex. numéro de projet, bon de commande ou service',
  'cust.form.creditLimit': 'Limite de crédit',
  'cust.form.creditLimitHint': 'Utilisée dans le rapprochement pour comparer le solde ouvert du client à la politique de crédit de l\'entreprise. Une limite ne bloque jamais la facturation.',
  'cust.form.creditLimitPh': 'Ex. 60000',
  'cust.form.note': 'Note client',
  'cust.form.notePh': 'Note sur le client',
  'cust.form.activity': 'Ajouter une note d\'activité',
  'cust.form.activityPh': 'Client appelé, mise à jour tarifaire envoyée…',
  'cust.form.update': 'Mettre à jour le client',
  'cust.form.save': 'Enregistrer le client',
  'cust.crm.prospect': 'Prospect',
  'cust.crm.quoteSent': 'Devis envoyé',
  'cust.crm.active': 'Client actif',
  'cust.crm.pause': 'En pause',
  'cust.chat.scope.all': 'Toute la conversation',
  'cust.chat.scope.to': 'Au client',
  'cust.chat.scope.from': 'Du client',
  'cust.chat.scope.internal': 'Notes internes',
  'cust.chat.helpAll': 'Vous voyez maintenant toute la conversation.',
  'cust.chat.helpTo': 'Vous voyez maintenant les messages que vous avez envoyés.',
  'cust.chat.helpFrom': 'Vous voyez maintenant les messages du client.',
  'cust.chat.helpInternal': 'Ce sont vos notes internes dans le dialogue.',
  'cust.chat.threadsHelpTitle': 'Conversations',
  'cust.chat.threadsHelp': 'Chaque client peut avoir plusieurs conversations. Passez de l\'une à l\'autre ici, ou démarrez un nouveau dialogue pour une nouvelle demande.',
  'cust.chat.conversation': 'Conversation',
  'cust.chat.filterTitle': 'Filtrer la conversation',
  'cust.chat.filterHelp': 'Choisissez ce que vous voulez voir dans la fenêtre ci-dessous : toute la conversation, les messages envoyés, les messages du client ou les notes internes.',
  'cust.chat.windowTitle': 'Fenêtre de conversation',
  'cust.chat.windowHelp': 'Les messages du dialogue. Ce que vous envoyez s\'affiche à droite, les messages du client et les notes internes à gauche. Faites glisser le bord inférieur pour agrandir la fenêtre.',
  'cust.chat.internal': 'Interne',
  'cust.chat.newInternalTitle': 'Nouvelle note interne',
  'cust.chat.saveInDialog': 'Enregistrer dans le dialogue',
  'cust.chat.saveMessage': 'Enregistrer le message',
  'cust.chat.sendMessage': 'Envoyer le message',
  'cust.chat.newTitle': 'Nouveau message',
  'cust.chat.newHelp': 'Rédigez une réponse au client, collez un message reçu ou notez quelque chose en interne. Le filtre de conversation choisi détermine si le contenu est envoyé au client, enregistré comme message client ou enregistré comme note interne.',
  'cust.chat.draftPh': 'Rédigez une réponse, collez un message client ou notez ce qui a été convenu...',
  'cust.chat.newDialog': 'Nouveau dialogue',
  'cust.chat.quoteTitle': 'Base de devis',
  'cust.chat.quoteHelp': 'Ajoutez les produits et prix convenus dans la conversation. Appuyez sur Créer un devis pour en faire un brouillon de devis avec le client déjà renseigné.',
  'cust.chat.findProduct': 'Trouver un produit/prix',
  'cust.chat.productPh': 'Rechercher un produit...',
  'cust.chat.dragToMessage': 'Glisser dans le message',
  'cust.chat.dragTotal': 'Glisser le total dans le message',
  'cust.chat.dragBasis': 'Glisser toute la base du devis dans le message',
  'cust.chat.quoteBasis': 'Toute la base',
  'cust.chat.remove': 'Retirer',
  'cust.chat.total': 'Total',
  'cust.chat.makeQuote': 'Créer un devis',
  'cust.toast.updated': 'Client mis à jour',
  'cust.toast.saved': 'Client enregistré',
  'cust.toast.saveFailed': 'Impossible d\'enregistrer le client.',
  'cust.toast.archived': 'Client déplacé vers l\'archive',
  'cust.toast.archiveFailed': 'Impossible d\'archiver le client.',
  'cust.toast.nothingToExport': 'Aucun client à exporter',
  'cust.toast.exportFailed': 'Impossible d\'exporter la liste des clients.',
  'cust.toast.exported': 'Liste des clients téléchargée',
  'cust.toast.noLedgerRows': 'Aucune ligne de compte client à exporter',
  'cust.toast.ledgerExportFailed': 'Impossible d\'exporter les comptes clients.',
  'cust.toast.ledgerExported': 'Comptes clients téléchargés',
  'cust.toast.wrongFormat': 'Utilisez un fichier CSV ou XLSX avec le modèle client Plumme.',
  'cust.toast.noneInFile': 'Aucun client trouvé dans le fichier.',
  'cust.toast.imported': '{n} clients importés',
  'cust.toast.importFailed': 'Impossible d\'importer les clients.',
  'cust.error.xlsxImport': 'L\'import XLSX n\'est pas encore disponible.',
  'cust.error.xlsxExport': 'L\'export Excel n\'est pas encore disponible.',
  'cust.export.number': 'N° client',
  'cust.export.name': 'Nom',
  'cust.export.org': 'N° d\'organisation',
  'cust.export.email': 'E-mail',
  'cust.export.phone': 'Téléphone',
  'cust.export.address': 'Adresse',
  'cust.export.zip': 'Code postal',
  'cust.export.city': 'Ville',
  'cust.export.status': 'Statut',
  'cust.export.followUp': 'Prochain suivi',
  'cust.export.defaultRef': 'Référence de facture fixe',
  'cust.export.note': 'Note',
  'cust.ledger.code': 'Code',
  'cust.ledger.date': 'Date',
  'cust.ledger.doc': 'N° de justificatif/facture',
  'cust.ledger.type': 'Type',
  'cust.ledger.due': 'Échéance',
  'cust.ledger.debit': 'Débit',
  'cust.ledger.credit': 'Crédit',
  'cust.ledger.balance': 'Solde après la ligne',
  'cust.ledger.paid': 'Payé',
  'cust.ledger.remaining': 'Restant',
  'cust.ledger.partial': 'Partiellement payé',
  'cust.ledger.unpaid': 'Non payé',
  'cust.ledger.posted': 'Comptabilisé',
  'cust.ledger.refund': 'Remboursement client',
  'cust.ledger.payment': 'Paiement client',
  'cust.ledger.creditOverpayment': 'Crédit / trop-perçu',
  'cust.ledger.empty': 'Aucune ligne de compte client pour le moment.',
  'cust.import': 'Importer',
  'cust.importFrom': 'Importer depuis',
  'cust.ledgerShort': 'Comptes clients',
  'cust.ledger.sheet': 'Comptes clients',
  'cust.sheet.customers': 'Clients',
});
